module.exports = __webpack_public_path__ + "public/files/img/avatar.6c25f23b.png";